"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property$ = exports.Property$outboundSchema = exports.Property$inboundSchema = void 0;
exports.propertyToJSON = propertyToJSON;
exports.propertyFromJSON = propertyFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const addresses_js_1 = require("./addresses.js");
const airportnoise_js_1 = require("./airportnoise.js");
const boolmeta_js_1 = require("./boolmeta.js");
const coastalerosion_js_1 = require("./coastalerosion.js");
const connectivity_js_1 = require("./connectivity.js");
const constructionmaterials_js_1 = require("./constructionmaterials.js");
const counciltax_js_1 = require("./counciltax.js");
const education_js_1 = require("./education.js");
const epcrating_js_1 = require("./epcrating.js");
const estimatedmarketvalue_js_1 = require("./estimatedmarketvalue.js");
const estimatedrentalvalue_js_1 = require("./estimatedrentalvalue.js");
const floodrisk_js_1 = require("./floodrisk.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
const hmo_js_1 = require("./hmo.js");
const intmeta_js_1 = require("./intmeta.js");
const listedbuilding_js_1 = require("./listedbuilding.js");
const localities_js_1 = require("./localities.js");
const marketstatistics_js_1 = require("./marketstatistics.js");
const multipleplanningapplication_js_1 = require("./multipleplanningapplication.js");
const nearbymonuments_js_1 = require("./nearbymonuments.js");
const occupancy_js_1 = require("./occupancy.js");
const outdoorspace_js_1 = require("./outdoorspace.js");
const ownership_js_1 = require("./ownership.js");
const planningapplicationswrapper_js_1 = require("./planningapplicationswrapper.js");
const plot_js_1 = require("./plot.js");
const propertyassets_js_1 = require("./propertyassets.js");
const propertyidentifiers_js_1 = require("./propertyidentifiers.js");
const propertylisting_js_1 = require("./propertylisting.js");
const propertylistings_js_1 = require("./propertylistings.js");
const propertytransactionattributes_js_1 = require("./propertytransactionattributes.js");
const propertytypeobject_js_1 = require("./propertytypeobject.js");
const recentlysoldtransaction_js_1 = require("./recentlysoldtransaction.js");
const restrictivecovenants_js_1 = require("./restrictivecovenants.js");
const rightofway_js_1 = require("./rightofway.js");
const streetview_js_1 = require("./streetview.js");
const stringmeta_js_1 = require("./stringmeta.js");
const tenure_js_1 = require("./tenure.js");
const titledeeds_js_1 = require("./titledeeds.js");
const transport_js_1 = require("./transport.js");
const utilities_js_1 = require("./utilities.js");
/** @internal */
exports.Property$inboundSchema = z.object({
    address: addresses_js_1.Addresses$inboundSchema.optional(),
    airport_noise: z.nullable(airportnoise_js_1.AirportNoise$inboundSchema).optional(),
    assets: z.nullable(z.array(propertyassets_js_1.PropertyAssets$inboundSchema)).optional(),
    coastal_erosion: z.nullable(coastalerosion_js_1.CoastalErosion$inboundSchema).optional(),
    connectivity: z.nullable(connectivity_js_1.Connectivity$inboundSchema).optional(),
    construction_age_band: z.nullable(z.string()).optional(),
    construction_materials: z.nullable(constructionmaterials_js_1.ConstructionMaterials$inboundSchema)
        .optional(),
    council_tax: z.nullable(counciltax_js_1.CouncilTax$inboundSchema).optional(),
    distance_from_point: z.nullable(z.number().int()).optional(),
    education: z.nullable(education_js_1.Education$inboundSchema).optional(),
    energy_performance: z.nullable(epcrating_js_1.EpcRating$inboundSchema).optional(),
    estimated_rental_values: z.nullable(estimatedrentalvalue_js_1.EstimatedRentalValue$inboundSchema)
        .optional(),
    estimated_value: z.nullable(z.number()).optional(),
    estimated_value_rounded: z.nullable(z.number()).optional(),
    estimated_values: z.nullable(z.array(estimatedmarketvalue_js_1.EstimatedMarketValue$inboundSchema))
        .optional(),
    flood_risk: z.nullable(floodrisk_js_1.FloodRisk$inboundSchema).optional(),
    hmo: z.nullable(hmo_js_1.Hmo$inboundSchema).optional(),
    identities: z.nullable(propertyidentifiers_js_1.PropertyIdentifiers$inboundSchema).optional(),
    internal_area_square_metres: z.nullable(intmeta_js_1.IntMeta$inboundSchema).optional(),
    is_bungalow: z.nullable(boolmeta_js_1.BoolMeta$inboundSchema).optional(),
    is_on_the_market: z.boolean().default(false),
    latest_transaction_date: z.nullable(z.string()).optional(),
    listed_buildings_on_plot: z.nullable(z.array(listedbuilding_js_1.ListedBuilding$inboundSchema))
        .optional(),
    localities: z.nullable(localities_js_1.Localities$inboundSchema).optional(),
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$inboundSchema).optional(),
    market_statistics: z.nullable(marketstatistics_js_1.MarketStatistics$inboundSchema).optional(),
    nearby_completed_transactions: z.nullable(z.array(recentlysoldtransaction_js_1.RecentlySoldTransaction$inboundSchema)).optional(),
    nearby_listed_buildings: z.nullable(z.array(listedbuilding_js_1.ListedBuilding$inboundSchema))
        .optional(),
    nearby_listings: z.nullable(propertylistings_js_1.PropertyListings$inboundSchema).optional(),
    nearby_planning_applications: z.nullable(z.array(multipleplanningapplication_js_1.MultiplePlanningApplication$inboundSchema)).optional(),
    nearby_scheduled_monuments: z.nullable(z.array(nearbymonuments_js_1.NearbyMonuments$inboundSchema))
        .optional(),
    number_of_bathrooms: z.nullable(intmeta_js_1.IntMeta$inboundSchema).optional(),
    number_of_bedrooms: z.nullable(intmeta_js_1.IntMeta$inboundSchema).optional(),
    occupancy: z.nullable(occupancy_js_1.Occupancy$inboundSchema).optional(),
    outdoor_space: z.nullable(outdoorspace_js_1.OutdoorSpace$inboundSchema).optional(),
    ownership: z.nullable(ownership_js_1.Ownership$inboundSchema).optional(),
    planning_applications: z.nullable(planningapplicationswrapper_js_1.PlanningApplicationsWrapper$inboundSchema)
        .optional(),
    plot: z.nullable(plot_js_1.Plot$inboundSchema).optional(),
    propensity_to_let_score: z.nullable(z.number()).optional(),
    propensity_to_sell_score: z.nullable(z.number()).optional(),
    property_listings: z.nullable(z.array(propertylisting_js_1.PropertyListing$inboundSchema))
        .optional(),
    property_type: z.nullable(propertytypeobject_js_1.PropertyTypeObject$inboundSchema).optional(),
    radon_risk_level: z.nullable(z.string()).optional(),
    restrictive_covenants: z.nullable(z.array(restrictivecovenants_js_1.RestrictiveCovenants$inboundSchema))
        .optional(),
    right_of_way: z.nullable(rightofway_js_1.RightOfWay$inboundSchema).optional(),
    street_group_property_id: z.string().optional(),
    street_view: z.nullable(streetview_js_1.StreetView$inboundSchema).optional(),
    tenure: z.nullable(tenure_js_1.Tenure$inboundSchema).optional(),
    title_deeds: z.nullable(titledeeds_js_1.TitleDeeds$inboundSchema).optional(),
    transactions: z.nullable(z.array(propertytransactionattributes_js_1.PropertyTransactionAttributes$inboundSchema))
        .optional(),
    transport: z.nullable(transport_js_1.Transport$inboundSchema).optional(),
    utilities: z.nullable(utilities_js_1.Utilities$inboundSchema).optional(),
    year_built: z.nullable(stringmeta_js_1.StringMeta$inboundSchema).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "airport_noise": "airportNoise",
        "coastal_erosion": "coastalErosion",
        "construction_age_band": "constructionAgeBand",
        "construction_materials": "constructionMaterials",
        "council_tax": "councilTax",
        "distance_from_point": "distanceFromPoint",
        "energy_performance": "energyPerformance",
        "estimated_rental_values": "estimatedRentalValues",
        "estimated_value": "estimatedValue",
        "estimated_value_rounded": "estimatedValueRounded",
        "estimated_values": "estimatedValues",
        "flood_risk": "floodRisk",
        "internal_area_square_metres": "internalAreaSquareMetres",
        "is_bungalow": "isBungalow",
        "is_on_the_market": "isOnTheMarket",
        "latest_transaction_date": "latestTransactionDate",
        "listed_buildings_on_plot": "listedBuildingsOnPlot",
        "market_statistics": "marketStatistics",
        "nearby_completed_transactions": "nearbyCompletedTransactions",
        "nearby_listed_buildings": "nearbyListedBuildings",
        "nearby_listings": "nearbyListings",
        "nearby_planning_applications": "nearbyPlanningApplications",
        "nearby_scheduled_monuments": "nearbyScheduledMonuments",
        "number_of_bathrooms": "numberOfBathrooms",
        "number_of_bedrooms": "numberOfBedrooms",
        "outdoor_space": "outdoorSpace",
        "planning_applications": "planningApplications",
        "propensity_to_let_score": "propensityToLetScore",
        "propensity_to_sell_score": "propensityToSellScore",
        "property_listings": "propertyListings",
        "property_type": "propertyType",
        "radon_risk_level": "radonRiskLevel",
        "restrictive_covenants": "restrictiveCovenants",
        "right_of_way": "rightOfWay",
        "street_group_property_id": "streetGroupPropertyId",
        "street_view": "streetView",
        "title_deeds": "titleDeeds",
        "year_built": "yearBuilt",
    });
});
/** @internal */
exports.Property$outboundSchema = z.object({
    address: addresses_js_1.Addresses$outboundSchema.optional(),
    airportNoise: z.nullable(airportnoise_js_1.AirportNoise$outboundSchema).optional(),
    assets: z.nullable(z.array(propertyassets_js_1.PropertyAssets$outboundSchema)).optional(),
    coastalErosion: z.nullable(coastalerosion_js_1.CoastalErosion$outboundSchema).optional(),
    connectivity: z.nullable(connectivity_js_1.Connectivity$outboundSchema).optional(),
    constructionAgeBand: z.nullable(z.string()).optional(),
    constructionMaterials: z.nullable(constructionmaterials_js_1.ConstructionMaterials$outboundSchema)
        .optional(),
    councilTax: z.nullable(counciltax_js_1.CouncilTax$outboundSchema).optional(),
    distanceFromPoint: z.nullable(z.number().int()).optional(),
    education: z.nullable(education_js_1.Education$outboundSchema).optional(),
    energyPerformance: z.nullable(epcrating_js_1.EpcRating$outboundSchema).optional(),
    estimatedRentalValues: z.nullable(estimatedrentalvalue_js_1.EstimatedRentalValue$outboundSchema)
        .optional(),
    estimatedValue: z.nullable(z.number()).optional(),
    estimatedValueRounded: z.nullable(z.number()).optional(),
    estimatedValues: z.nullable(z.array(estimatedmarketvalue_js_1.EstimatedMarketValue$outboundSchema))
        .optional(),
    floodRisk: z.nullable(floodrisk_js_1.FloodRisk$outboundSchema).optional(),
    hmo: z.nullable(hmo_js_1.Hmo$outboundSchema).optional(),
    identities: z.nullable(propertyidentifiers_js_1.PropertyIdentifiers$outboundSchema).optional(),
    internalAreaSquareMetres: z.nullable(intmeta_js_1.IntMeta$outboundSchema).optional(),
    isBungalow: z.nullable(boolmeta_js_1.BoolMeta$outboundSchema).optional(),
    isOnTheMarket: z.boolean().default(false),
    latestTransactionDate: z.nullable(z.string()).optional(),
    listedBuildingsOnPlot: z.nullable(z.array(listedbuilding_js_1.ListedBuilding$outboundSchema))
        .optional(),
    localities: z.nullable(localities_js_1.Localities$outboundSchema).optional(),
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$outboundSchema).optional(),
    marketStatistics: z.nullable(marketstatistics_js_1.MarketStatistics$outboundSchema).optional(),
    nearbyCompletedTransactions: z.nullable(z.array(recentlysoldtransaction_js_1.RecentlySoldTransaction$outboundSchema)).optional(),
    nearbyListedBuildings: z.nullable(z.array(listedbuilding_js_1.ListedBuilding$outboundSchema))
        .optional(),
    nearbyListings: z.nullable(propertylistings_js_1.PropertyListings$outboundSchema).optional(),
    nearbyPlanningApplications: z.nullable(z.array(multipleplanningapplication_js_1.MultiplePlanningApplication$outboundSchema)).optional(),
    nearbyScheduledMonuments: z.nullable(z.array(nearbymonuments_js_1.NearbyMonuments$outboundSchema))
        .optional(),
    numberOfBathrooms: z.nullable(intmeta_js_1.IntMeta$outboundSchema).optional(),
    numberOfBedrooms: z.nullable(intmeta_js_1.IntMeta$outboundSchema).optional(),
    occupancy: z.nullable(occupancy_js_1.Occupancy$outboundSchema).optional(),
    outdoorSpace: z.nullable(outdoorspace_js_1.OutdoorSpace$outboundSchema).optional(),
    ownership: z.nullable(ownership_js_1.Ownership$outboundSchema).optional(),
    planningApplications: z.nullable(planningapplicationswrapper_js_1.PlanningApplicationsWrapper$outboundSchema)
        .optional(),
    plot: z.nullable(plot_js_1.Plot$outboundSchema).optional(),
    propensityToLetScore: z.nullable(z.number()).optional(),
    propensityToSellScore: z.nullable(z.number()).optional(),
    propertyListings: z.nullable(z.array(propertylisting_js_1.PropertyListing$outboundSchema))
        .optional(),
    propertyType: z.nullable(propertytypeobject_js_1.PropertyTypeObject$outboundSchema).optional(),
    radonRiskLevel: z.nullable(z.string()).optional(),
    restrictiveCovenants: z.nullable(z.array(restrictivecovenants_js_1.RestrictiveCovenants$outboundSchema))
        .optional(),
    rightOfWay: z.nullable(rightofway_js_1.RightOfWay$outboundSchema).optional(),
    streetGroupPropertyId: z.string().optional(),
    streetView: z.nullable(streetview_js_1.StreetView$outboundSchema).optional(),
    tenure: z.nullable(tenure_js_1.Tenure$outboundSchema).optional(),
    titleDeeds: z.nullable(titledeeds_js_1.TitleDeeds$outboundSchema).optional(),
    transactions: z.nullable(z.array(propertytransactionattributes_js_1.PropertyTransactionAttributes$outboundSchema)).optional(),
    transport: z.nullable(transport_js_1.Transport$outboundSchema).optional(),
    utilities: z.nullable(utilities_js_1.Utilities$outboundSchema).optional(),
    yearBuilt: z.nullable(stringmeta_js_1.StringMeta$outboundSchema).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        airportNoise: "airport_noise",
        coastalErosion: "coastal_erosion",
        constructionAgeBand: "construction_age_band",
        constructionMaterials: "construction_materials",
        councilTax: "council_tax",
        distanceFromPoint: "distance_from_point",
        energyPerformance: "energy_performance",
        estimatedRentalValues: "estimated_rental_values",
        estimatedValue: "estimated_value",
        estimatedValueRounded: "estimated_value_rounded",
        estimatedValues: "estimated_values",
        floodRisk: "flood_risk",
        internalAreaSquareMetres: "internal_area_square_metres",
        isBungalow: "is_bungalow",
        isOnTheMarket: "is_on_the_market",
        latestTransactionDate: "latest_transaction_date",
        listedBuildingsOnPlot: "listed_buildings_on_plot",
        marketStatistics: "market_statistics",
        nearbyCompletedTransactions: "nearby_completed_transactions",
        nearbyListedBuildings: "nearby_listed_buildings",
        nearbyListings: "nearby_listings",
        nearbyPlanningApplications: "nearby_planning_applications",
        nearbyScheduledMonuments: "nearby_scheduled_monuments",
        numberOfBathrooms: "number_of_bathrooms",
        numberOfBedrooms: "number_of_bedrooms",
        outdoorSpace: "outdoor_space",
        planningApplications: "planning_applications",
        propensityToLetScore: "propensity_to_let_score",
        propensityToSellScore: "propensity_to_sell_score",
        propertyListings: "property_listings",
        propertyType: "property_type",
        radonRiskLevel: "radon_risk_level",
        restrictiveCovenants: "restrictive_covenants",
        rightOfWay: "right_of_way",
        streetGroupPropertyId: "street_group_property_id",
        streetView: "street_view",
        titleDeeds: "title_deeds",
        yearBuilt: "year_built",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Property$;
(function (Property$) {
    /** @deprecated use `Property$inboundSchema` instead. */
    Property$.inboundSchema = exports.Property$inboundSchema;
    /** @deprecated use `Property$outboundSchema` instead. */
    Property$.outboundSchema = exports.Property$outboundSchema;
})(Property$ || (exports.Property$ = Property$ = {}));
function propertyToJSON(property) {
    return JSON.stringify(exports.Property$outboundSchema.parse(property));
}
function propertyFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Property$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Property' from JSON`);
}
//# sourceMappingURL=property.js.map